"use strict";

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var StringUtils = /*#__PURE__*/function () {
  function StringUtils() {
    _classCallCheck(this, StringUtils);
  }

  _createClass(StringUtils, null, [{
    key: "parseCmsVars",

    /**
     * Replaces all instances of a CMS variable with the provided value
     * e.g. replaces `${FIRST_NAME}` with `John`
     *
     * @param {String} source - String containing one or more instances of the variable
     * @param {Object} pairs - Key/value pairs for variable names the value to replace them with
     */
    value: function parseCmsVars(source, pairs) {
      return source.replace(/#\{([^\}]+)\}/g, function (match, key) {
        return pairs[key] || match;
      });
    }
    /**
     * @param {string} input e.g. 'SOME STRING'
     * @returns {string} kebab case equivalent e.g. 'some-string'
     */

  }, {
    key: "kebabCase",
    value: function kebabCase(input) {
      return input.toLowerCase().replace(/\s/g, '-');
    }
    /**
     * @param {string} input e.g. 'SOME STRING'
     * @returns {string} snake case equivalent e.g. 'some_string'
     */

  }, {
    key: "snakeCase",
    value: function snakeCase(input) {
      return input.toLowerCase().replace(/\s/g, '_');
    }
    /**
     * Reference: https://stackoverflow.com/questions/2970525/converting-any-string-into-camel-case
     *
     * @param {string} input e.g. 'SOME STRING', 'some string'
     * @returns {string} camel case equivalent e.g. 'someString'
     */

  }, {
    key: "camelCase",
    value: function camelCase(input) {
      return input.toLowerCase().split(' ').map(function (item, index) {
        return index !== 0 ? item.charAt(0).toUpperCase() + item.substr(1) : item.charAt(0).toLowerCase() + item.substr(1);
      }).join('');
    }
    /**
     * @param {string} input e.g. 'some string'
     * @returns {string} first letter in uppercase e.g. 'Some string'
     */

  }, {
    key: "firstLetterUpperCase",
    value: function firstLetterUpperCase(input) {
      return input.charAt(0).toUpperCase() + input.slice(1);
    }
    /**
     * This will create a short guid
     *
     * @returns {string} guid
     */

  }, {
    key: "createGuid",
    value: function createGuid() {
      /*eslint-disable */
      return 'xxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
      /*eslint-enable */
    }
  }]);

  return StringUtils;
}();

exports.default = StringUtils;
//# sourceMappingURL=StringUtils.js.map